import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3f73820"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contentWrapper" }
const _hoisted_2 = {
  class: "content",
  ref: "mainContent"
}

import { onMounted, onUnmounted, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentWrapper',
  props: {
  backgroundImageClass: {
    type: String,
    default: () => "",
  },
},
  setup(__props) {



const state = reactive({
  backgroundFadePercentage: 1,
});

function fadeBackgroundBasedOnScroll() {
  let fadeAmount = 1.0 - window.scrollY / (window.innerHeight * 0.5);

  if (fadeAmount <= 0.5) {
    fadeAmount = 0.5;
  }
  state.backgroundFadePercentage = fadeAmount;
}

onMounted(() => {
  window.addEventListener("scroll", () => fadeBackgroundBasedOnScroll());
});

onUnmounted(() => {
  window.removeEventListener("scroll", () => fadeBackgroundBasedOnScroll());
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([`background-image`, __props.backgroundImageClass]),
      style: _normalizeStyle(`filter: opacity(${state.backgroundFadePercentage});`)
    }, null, 6),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ], 512)
  ]))
}
}

})